// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1_H6e","itemTitle":"ClientEmergencyInfo_itemTitle__1y7NN","itemText":"ClientEmergencyInfo_itemText__3wrQW"};